import { createApp } from "vue"
import { createPinia } from "pinia"
import router from "./router"
import i18n from "./locales"
import { useAuthStore } from "./stores/auth"
import { useBrandStore } from "./stores/brand"
import { useThemeStore } from "./stores/theme"
import { initPostHog } from "./analytics"
import { initSentry } from "./sentry"
import { installStaleAssetRecovery, reportStaleAssetRecovery } from "./utils/staleAssetRecovery"
import "@fontsource/archivo/400.css"
import "@fontsource/archivo/500.css"
import "@fontsource/archivo/600.css"
import "./style.css"
import App from "./App.vue"
import { startDemo } from "./demo"

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)
app.use(i18n)

// The demo build answers the API in the browser and leaves monitoring off (src/demo/). The condition is constant per
// build, so every other build drops the branch — and the demo's code with it. Before restoreSession, whose first
// request must already reach the demo's API.
if (import.meta.env.MODE === "demo") {
  startDemo(pinia, router)
} else {
  initPostHog()
  initSentry({ app, router })
}
installStaleAssetRecovery(router)

// Before the first paint, so the stripe and theme colour come from the last session instead of flashing the default
useBrandStore()
useThemeStore()

const authStore = useAuthStore()

authStore
  .restoreSession()
  .catch(error => {
    console.error("Failed to restore session:", error)
  })
  .finally(() => {
    reportStaleAssetRecovery()
    app.mount("#app")
  })
